import { Component, Input, forwardRef } from '@angular/core';
import {
  UntypedFormControl,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Moment } from 'moment';

@Component({
  selector: 'lum-ui-datepicker',
  templateUrl: './ui-datepicker.component.html',
  styleUrls: ['./ui-datepicker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiDatepickerComponent),
      multi: true,
    },
  ],
})
export class UiDatepickerComponent implements ControlValueAccessor{
  @Input()
  placeholder :string = '';

  @Input()
  disabled :boolean;

  @Input()
  formControl :UntypedFormControl;

  private onChange :(value :any) => void;
  private onTouched :() => void;

  writeValue(value :any) :void {
    if (value && value !== this.formControl.value) {
      this.formControl.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn :(value :any) => void) :void {
    this.onChange = fn;
  }

  registerOnTouched(fn :() => void) :void {
    this.onTouched = fn;
  }

  onFilterChange(event :Moment) :void {
    if (!event) {
      return;
    }

    const formattedValue = event.format('YYYY-MM-DD');
    this.formControl.setValue(formattedValue);
    if (this.onChange) {
      this.onChange(formattedValue);
    }
  }
}
